module.exports = __webpack_public_path__ + "img/bule7.fa2a8e28.png";